

$(function () {
    init();
    initProgressBars();
});

function init() {
    detectFeatures();
    document.createElement('section');
}

//#StemsAccountsDev: OBSOLETE!!! Used only in Company details page which will be refactored
function initProgressBars() {
    $("[stems-progress]").each(function (idx, element) {
        var value = $(element).attr("stems-progress");
        $(element).animate({
            width: value
        }, 500);
    });
}

/*
 * All feature-detection logic SHOULD go here for easy maintenance and scalability.
 * This function uses Modernizr to detect supported browser features.
 * The Modernizr library does NOT contain all the features in order to the file small it
 * only includes the following features at the moment:
 * - CSS Animations Detection
 * 
 * If you need to add more feature-detection go to https://modernizr.com/download?setclasses
 * 1- select the features you need (make sure to also select the ones listed above)
 * 2- Update the list above with the features you added
 * 3- Download the NOT MINIFIED version of the file
 * 4- Replace the copy in this solution
 */
function detectFeatures() {
    if (!Modernizr.cssanimations) {
        //finds all elements that have the spinner class, adds another class that
        //removes unsupported css properties and replaces its content
        $(".spinner").removeClass("spinner").addClass("loading").html("...loading...");
    }
}





